import {cssTheme} from '@yandex-delivery/blocks';
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const mobileClasses = {
  root:css`
    background: ${cssTheme.colors.deliveryGrey[500]};
    block-size: ${spacing(5)};
    justify-content: center;
  `,
  gap: css`
    margin-inline-end: ${spacing(4.5)};
  `,
  label: css`
    cursor: pointer;
    &:hover, &:active {
      color: ${cssTheme.colors.deliveryGrey[200]};
    }
  `,
  icon: css`
    margin-block-start: ${spacing(0.375)};
    transform: rotate(-180deg);
  `,
}
